import type { Logger } from './config';

export function createConsoleLogger(): Logger {
  return {
    debug(message: string, meta?: Record<string, unknown>) {
      console.log(`[Vesant SDK] ${message}`, meta !== undefined ? meta : '');
    },
    info(message: string, meta?: Record<string, unknown>) {
      console.info(`[Vesant SDK] ${message}`, meta !== undefined ? meta : '');
    },
    warn(message: string, meta?: Record<string, unknown>) {
      console.warn(`[Vesant SDK] ${message}`, meta !== undefined ? meta : '');
    },
    error(message: string, meta?: Record<string, unknown>) {
      console.error(`[Vesant SDK] ${message}`, meta !== undefined ? meta : '');
    },
  };
}

export const noopLogger: Logger = {
  debug() {},
  info() {},
  warn() {},
  error() {},
};
